import React, { useEffect, useState } from 'react';
import { Tabs, Tab } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { IFiltersTabs } from './types';
import { TSearchTabsFilters } from 'src/components/Search/components/types';
import useAuth from 'src/hooks/useAuth';

/**
 * Represents the header of the filters section of the lead list view.
 *
 * @return {*}
 */
export const FiltersTabs = <TField,>({
    arrayKeys,
    stringKeys,
    booleanKeys,
    tabs,
    disable,
    defaultFilters,
    values,
    setValues,
}: IFiltersTabs<TField>) => {
    const { t } = useTranslation();
    const [tabValue, setTabValue] = useState<string>('all');
    const { user } = useAuth();

    const handleChangeTab = (_: React.ChangeEvent<{}>, newKey: string) => {
        setTabValue(newKey);

        const selectedTab = tabs.find((tab) => tab.key === newKey);

        if (!selectedTab || selectedTab.key === 'all') {
            setValues(defaultFilters);
            return;
        }

        const { type, value, label } = selectedTab;

        let fieldValue: any = null;

        if (arrayKeys?.includes(String(type)))
            fieldValue = [{ value: String(value), label: t(label) }];

        if (stringKeys?.includes(String(type))) fieldValue = String(value);

        if (booleanKeys?.includes(String(type))) fieldValue = Boolean(value);

        const response = {
            ...defaultFilters,
            isTabsEnabled: true,
            isQueryEnabled: values.isQueryEnabled,
            query: values.query,
            tabValue: newKey,
            [String(type)]: fieldValue,
        };
        setValues(response);
    };

    useEffect(() => {
        if (values?.tabValue) setTabValue(values.tabValue);
    }, [values?.tabValue]);

    return (
        <Tabs
            value={tabValue}
            onChange={handleChangeTab}
            variant="scrollable"
            data-testid="tabs-filters"
        >
            {tabs.map((tab: TSearchTabsFilters) => {
                if (tab?.notAccess && tab?.notAccess?.includes(user?.accessLevel))
                    return null;
                const tabLabel: string = t(tab.label);
                return (
                    <Tab
                        key={tab.key}
                        value={tab.key}
                        label={tabLabel}
                        disabled={disable}
                        data-testid={`tab-${tab.key}`}
                    />
                );
            })}
        </Tabs>
    );
};
